import React, { useEffect, useState, useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import "./AIAcademyContent.css";
import AOS from "aos";
import "aos/dist/aos.css";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import "../HomeFolder/HomeNavbarmenu.css";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import "../HomeFolder/HomeSideNavbar.css";
import "../MobileResponsiveness.css";
import "../Searchnav.css";
import { ProgramComponentsData } from "./ProgramComponentsData.jsx";
import ExplorebyProgram from './ExplorebyProgram.jsx';
import ExplorebyRoles from "./ExplorebyRoles.jsx";
import ExplorebyTopic from "./ExplorebyTopic.jsx";
import { SearchBar } from "../../Pages/Search.jsx";
import { useDispatch, useSelector } from "react-redux";
import { onChange } from "../Redux/SearchSlice.js";

function AIAcademyContent() {

  const tabLabels = ["Explore by Topic", "Explore by Roles", "Explore by Program"];
  const [activeTab, setActiveTab] = useState(tabLabels[0]);
  const [activeIndex, setActiveIndex] = useState(0);
  const tabContainerRef = useRef(null);

  const handleArrowClick = (direction) => {
    let newIndex = activeIndex;
    if (direction === "left" && activeIndex > 0) newIndex--;
    if (direction === "right" && activeIndex < tabLabels.length - 1) newIndex++;
    setActiveTab(tabLabels[newIndex]);
    setActiveIndex(newIndex);
    centerActiveTab(newIndex);
  };

  const centerActiveTab = (index) => {
    const container = tabContainerRef.current;
    const tab = container?.children[index];
    if (container && tab) {
      const containerWidth = container.offsetWidth;
      const tabWidth = tab.offsetWidth;
      const scrollPosition = tab.offsetLeft - containerWidth / 2 + tabWidth / 2;
      container.scrollTo({ left: scrollPosition, behavior: "smooth" });
    }
  };
   const dispatch = useDispatch()
   const onMouseClick = () =>{
             dispatch(onChange())
  }
  useEffect(() => {
    AOS.init({ duration: 800 });
    onMouseClick()
  }, []);

  const selector = useSelector(state=>state?.search?.value)
  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
       {selector && selector!==""? <SearchBar/>: <>
      <div className="video-container" id="main">
        <title>L-TT AI Academy</title>
        <h1 class="sr-only" tabIndex={0}>
          AI Academy
        </h1>
        <img
          src={process.env.PUBLIC_URL + "/images/AIAcademy/New-Banner.png"}
          alt="AIAcademy-Banner"
          className="banner-img desktop-banner"
        />
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/AIAcademy/BannerwithText.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/AI-Academy"
            >
              AI Academy
            </NavLink>
          </li>
        </ul>
        <div className="heading-text-box">
          <h1 tabIndex={0}>AI Academy</h1>
          <p>
            Empowering Every Role with AI Skills.
          </p>
        </div>
      </div>

      {/* first section */}
      <div className="agentic-ai-container">
        <div className="agentic-ai-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Overview</h2>
          </div>
          <p className="overview-content">
            AI Academy empowers professionals across all roles to build essential AI skills that enhance
            productivity, innovation, and informed decision-making. Through focused, role based learning,
            it prepares individuals to apply AI effectively and contribute to organizational growth in
            a digital-first world.
          </p>
        </div>
      </div>

      <section className="academies-tracks-section" data-aos="fade-up">
        <div className="academies-tracks-wrap">
          <button
            className="tab-arrow left-arrow"
            onClick={() => handleArrowClick("left")}
            aria-label="Scroll left"
          >
            &#10094;
          </button>
          <div className="tabs-container"  ref={tabContainerRef}>
            {tabLabels.map((label) => (
            <button
              key={label}
              className={`tab-item ${activeTab === label ? "active" : ""}`}
              onClick={() => setActiveTab(label)}
            >
              {label}
            </button>
          ))}
          </div>

          <button
            className="tab-arrow right-arrow"
            onClick={() => handleArrowClick("right")}
            aria-label="Scroll right"
          >
            &#10095;
          </button>
          {/* Tab Content */}
          <div className="track-grid">
            {activeTab === "Explore by Topic" && <ExplorebyTopic />}
            {activeTab === "Explore by Roles" && <ExplorebyRoles />}
            {activeTab === "Explore by Program" && <ExplorebyProgram />}
          </div>
        </div>
      </section>
      </>}
    </>
  );
}

export default AIAcademyContent;
